module.exports = __webpack_public_path__ + "img/newsIndImg8.a49c75c9.png";